import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9bc1c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "cc-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cc-header__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-compass" })
], -1))
const _hoisted_5 = { class: "cc-header__title" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "cc-body" }
const _hoisted_10 = {
  key: 0,
  class: "cc-state"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "cc-state"
}
const _hoisted_14 = { class: "cc-muted" }
const _hoisted_15 = {
  key: 2,
  class: "cc-intro"
}
const _hoisted_16 = { class: "cc-intro__title" }
const _hoisted_17 = { class: "cc-intro__text" }
const _hoisted_18 = { class: "cc-intro__meta" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock" }, null, -1))
const _hoisted_20 = { class: "cc-intro__note" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
const _hoisted_22 = {
  key: 3,
  class: "cc-quiz"
}
const _hoisted_23 = { class: "cc-quiz__progress" }
const _hoisted_24 = { class: "cc-bar" }
const _hoisted_25 = {
  key: 0,
  class: "cc-quiz__hint"
}
const _hoisted_26 = { class: "cc-quiz__question" }
const _hoisted_27 = ["aria-pressed", "onClick"]
const _hoisted_28 = { class: "cc-option__label" }
const _hoisted_29 = {
  key: 0,
  class: "cc-option__description"
}
const _hoisted_30 = {
  key: 1,
  class: "cc-error"
}
const _hoisted_31 = { class: "cc-quiz__footer" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "bi bi-arrow-right"
}

import { computed, onBeforeUnmount, watch } from "vue";
import "@/modern/styles/lp.scss";
import { useCareerCompass } from "@/modern/composables/useCareerCompass";
import { useCareerCompassI18n } from "@/modern/components/careerCompass/careerCompassI18n";
import CareerCompassResult from "@/modern/components/careerCompass/CareerCompassResult.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({ (e: "close"): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean }

/**
 * Bússola de carreira — aberta pelo ícone de bússola no topo (Topbar.vue).
 *
 * Abre no último resultado salvo, quando existe; senão, na introdução do quiz.
 * Recarrega a cada abertura para o progresso nas trilhas vir atualizado.
 */



const { tc } = useCareerCompassI18n();
const {
  result,
  mode,
  answers,
  stepIndex,
  totalSteps,
  currentStep,
  isLastStep,
  canSubmit,
  isSubmitting,
  submitError,
  load,
  start,
  select,
  back,
  submit,
} = useCareerCompass();

const progress = computed(() => Math.round(((stepIndex.value + 1) / totalSteps.value) * 100));

const question = computed(() => {
  const step = currentStep.value;
  if (!step) return "";
  if (step.kind === "profile") return tc("question_profile");
  if (step.kind === "goal") return tc("question_goal");
  return tc(`questions.${step.id}`);
});

const optionLabel = (option: string): string => {
  const kind = currentStep.value?.kind;
  if (kind === "profile") return tc(`profiles.${option}.label`);
  if (kind === "goal") return tc(`goals.${option}`);
  return tc(`level_options.${option}`);
};

const close = () => emit("close");

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === "Escape") close();
};

watch(
  () => props.open,
  (open) => {
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      window.addEventListener("keydown", onKeydown);
      load();
    } else {
      window.removeEventListener("keydown", onKeydown);
    }
  }
);

onBeforeUnmount(() => {
  document.body.style.overflow = "";
  window.removeEventListener("keydown", onKeydown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "cc-fade" }, {
      default: _withCtx(() => [
        (__props.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "lp-page cc-overlay",
              onClick: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", {
                class: "lp-card cc-dialog",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": _unref(tc)('title')
              }, [
                _createElementVNode("header", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(tc)("title")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "lp-btn lp-btn--ghost cc-header__close",
                    "aria-label": _unref(tc)('close'),
                    onClick: close
                  }, _hoisted_8, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_unref(mode) === 'loading')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                    : (_unref(mode) === 'error')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(tc)("load_error")), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "lp-btn lp-btn--outline",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(load) && _unref(load)(...args)))
                          }, _toDisplayString(_unref(tc)("retry")), 1)
                        ]))
                      : (_unref(mode) === 'intro')
                        ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                            _createElementVNode("h3", _hoisted_16, _toDisplayString(_unref(tc)("intro_title")), 1),
                            _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(tc)("intro_text")), 1),
                            _createElementVNode("p", _hoisted_18, [
                              _hoisted_19,
                              _createTextVNode(" " + _toDisplayString(_unref(tc)("intro_meta", { count: _unref(totalSteps) })), 1)
                            ]),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(tc)("intro_note")), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "lp-btn",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(start) && _unref(start)(...args)))
                            }, [
                              _createTextVNode(_toDisplayString(_unref(tc)("start")) + " ", 1),
                              _hoisted_21
                            ])
                          ]))
                        : (_unref(mode) === 'quiz' && _unref(currentStep))
                          ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("span", null, _toDisplayString(_unref(tc)("step", { current: _unref(stepIndex) + 1, total: _unref(totalSteps) })), 1),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", {
                                    class: "cc-bar__value",
                                    style: _normalizeStyle({ width: `${_unref(progress)}%` })
                                  }, null, 4)
                                ])
                              ]),
                              (_unref(currentStep).kind === 'level')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_unref(tc)("level_hint")), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("h3", _hoisted_26, _toDisplayString(_unref(question)), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["cc-options", { 'cc-options--inline': _unref(currentStep).kind === 'level' }])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentStep).options, (option) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: option,
                                    type: "button",
                                    class: _normalizeClass(["cc-option", { 'cc-option--selected': _unref(answers)[_unref(currentStep).id] === option }]),
                                    "aria-pressed": _unref(answers)[_unref(currentStep).id] === option,
                                    onClick: ($event: any) => (_unref(select)(option))
                                  }, [
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(optionLabel(option)), 1),
                                    (_unref(currentStep).kind === 'profile')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(tc)(`profiles.${option}.description`)), 1))
                                      : _createCommentVNode("", true)
                                  ], 10, _hoisted_27))
                                }), 128))
                              ], 2),
                              (_unref(submitError))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_unref(tc)("submit_error")), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("footer", _hoisted_31, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "lp-btn lp-btn--ghost",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(back) && _unref(back)(...args)))
                                }, [
                                  _hoisted_32,
                                  _createTextVNode(" " + _toDisplayString(_unref(tc)("back")), 1)
                                ]),
                                (_unref(isLastStep))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "lp-btn",
                                      disabled: !_unref(canSubmit) || _unref(isSubmitting),
                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
                                    }, [
                                      _createTextVNode(_toDisplayString(_unref(isSubmitting) ? _unref(tc)("submitting") : _unref(tc)("submit")) + " ", 1),
                                      (!_unref(isSubmitting))
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_33))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_unref(mode) === 'result' && _unref(result))
                            ? (_openBlock(), _createBlock(CareerCompassResult, {
                                key: 4,
                                result: _unref(result),
                                onRedo: _unref(start),
                                onNavigate: close
                              }, null, 8, ["result", "onRedo"]))
                            : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_2)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})